// software license for '@ua-parser-js/pro-business' was purchased by Marc
import { UAParser as userAgentParser } from '@ua-parser-js/pro-business'
import { NextPageContext } from 'next/types'

/**
 * Since there is no `isServer` property in `ctx` (it's provided by webpack),
 * we can check whether `req` (or `res`) is undefined to determine if we're
 * running on the server or client.
 * @see https://github.com/vercel/next.js/issues/2946#issuecomment-329235139
 */
export const isServer = (ctx: NextPageContext) => !!ctx.req

export const ssrIsIOS = (ctx: NextPageContext) => {
    const userAgent = ctx.req?.headers
        ? ctx.req.headers['user-agent']
        : typeof window !== 'undefined'
          ? window.navigator.userAgent
          : undefined
    if (!userAgent) return undefined
    const parser = new userAgentParser()

    return parser.setUA(userAgent).getOS().name === 'iOS'
}

export const ssrIsMobile = (ctx: NextPageContext) => {
    const userAgent = ctx.req?.headers
        ? ctx.req.headers['user-agent']
        : typeof window !== 'undefined'
          ? window.navigator.userAgent
          : undefined
    if (!userAgent) return undefined
    const parser = new userAgentParser()
    return parser.setUA(userAgent).getDevice().type === 'mobile'
}
